import { FinderBase } from './FinderBase';

export class FinderDistinteStatiche extends FinderBase
{
    public soloDistinteDaValidare: boolean = false;
    public soloDistinteInDraft: boolean = false;
    public soloDistinteValidateESincronizzate: boolean = false;
    public filtroStagioni: string[] = [];
    public filtroColori: string[] = [];
    public filtroModelli: string[] = [];
    public filtroLineaVendita: string[] = [];
    public filtroAvanzamentiProduzione: string[] = [];

    public filtroVariazioniDaData?: Date;
    public filtroVariazioniAData?: Date;

    public constructor(pagina?: number) {
        super();
        
        if(pagina) {
            this.numeroPagina = pagina;
        }        
    }

    public isValid() : boolean {
        var filtroStagionePresente = this.filtroStagioni && this.filtroStagioni.length > 0;
        var filtroColorePresente = this.filtroColori && this.filtroColori.length > 0;
        var filtroModelloPresente = this.filtroModelli && this.filtroModelli.length > 0;

        return filtroModelloPresente || filtroColorePresente || filtroStagionePresente || this.soloDistinteDaValidare === true;
    }
}